import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

export type IntegrationProvider = 'partstrader' | 'ccc' | 'mitchell' | 'tesla' | 'opstrax' | 'collisionlink';

export interface OrgLevelCredential {
    _id: string;
    username: string;
    password: string | null;
}

export interface LocationLevelCredential {
    _id: string;
    locationId: string | null;
    locationTitle: string | null;
    username: string;
    password: string | null;
}

export type OpstraxCredential = LocationLevelCredential;

export interface IntegrationsLocation {
    _id: string;
    title: string;
}

export interface NexIntegration {
    customerGuid: string | null;
    managementSystem: 'ccc' | 'nex' | null;
}

export interface IntegrationsResponse {
    partstrader: OrgLevelCredential[];
    ccc: OrgLevelCredential[];
    mitchell: LocationLevelCredential[];
    tesla: OrgLevelCredential[];
    opstrax: OpstraxCredential[];
    collisionlink: LocationLevelCredential[];
    nex?: NexIntegration;
    locations: IntegrationsLocation[];
}

const getIntegrations = async (sessionId: string): Promise<IntegrationsResponse> => {
    const { data } = await axios.get(`${API_URL}/settings/account/integrations`, {
        headers: { Authorization: sessionId },
    });
    return data;
};

export const useGetIntegrations = (enabled: boolean = true) => {
    const sessionContext = useContext(SessionContext);
    return useQuery({
        queryKey: ['integrations'],
        queryFn: () => getIntegrations(sessionContext?.sessionId ?? ''),
        enabled,
    });
};
